module.exports = __webpack_public_path__ + "static/media/location_pin.ff2ace31.png";